// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9219":"e4938b2e","9305":"e4938b2e"}[chunkId] + ".chunk.css";
};